import { styled, Grid } from "@mui/material";

export const Container = styled(Grid)(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  textAlign: "center",
  justifyContent: "center",
  backgroundColor: theme.palette.background.paper,
  padding: "25px",
  width: "70%",
  maxWidth: "70%",
  overflow: "auto",
  height: "70vh",
  "& .MuiTypography-root": {
    color: theme.palette.secondary.light,
  },
}));
